
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import AppPanel from '../fw/AppPanel.react';

import types from '../../common/model-api/types';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import {wrapNotFound} from "../app/NotFoundHandler.react";
import urlMapping from '../app/URLMapping';
import PagingGrid from '../fw/PagingGrid.react';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'organisationList.title', 'defaultMessage': 'Organisations'},
});

interface ScenarioOrganisationListProps {
    intl: IntlShape;
    relay?: object;
    user: User;
}

class ScenarioOrganisationList extends React.Component<ScenarioOrganisationListProps> {

    typeName = 'organisations';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired
    };

    constructor() {
        super();
    }

    render() {
        const scenario = this.props.user.scenarios.edges[0].node;
        let { organisations } = scenario;

        return (
            <AppPanel  breadcrumbParams={[
                {type: types['scenarios'], data: scenario}]
            } title={this.props.intl.formatMessage(messages.title)}>
                <span style={{"float": "right"}}># {organisations.edges.length}</span>

                <PagingGrid
                    columns={{
                        'name': {
                            render: (column, item, url, columnMapping) => {
                                if (item) {
                                    return (
                                        <div>{item.name}<br/>
                                        <small>{item.adminUsers.edges.map(({node}) => node.email).join(", ")}</small>
                                        </div>
                                    );
                                } else {
                                    return (
                                        "-"
                                    );
                                }
                            }
                        },
                        'createdAt': {
                            link: false,
                        },
                    }}
                    edges={organisations}
                    getUrl={(organisation) => {
                        let url = urlMapping.getUrl(types['organisations'], 'view', {id: organisation.id});
                        return url;
                    }}
                    metadata={types['organisations']}
                    pageInfo={organisations.pageInfo}
                    parent={this.props.user.scenario}
                    relay={this.props.relay}
                    urlMapping={urlMapping} />

            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(ScenarioOrganisationList), (props) => {
    return props.user.scenarios.edges.length > 0;
}), {
    initialVariables: {
        first: 2000,
        after: null,
        before: null,
        last: null,
        scenarioUrlFragment: '',
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                scenarios(first: 1, urlFragment: $scenarioUrlFragment) {
                    edges {
                        node {
                            id,
                            realId,
                            name,
                            title,
                            organisations(first: $first, after: $after, before: $before, last: $last) {
                                edges {
                                    node {
                                        id,
                                        name,
                                        email,
                                        createdAt,
                                        adminUsers(first: 4) {
                                            edges {
                                                node {
                                                    id,
                                                    email,
                                                }
                                            }
                                        }
                                    }
                                },
                                pageInfo {
                                    hasNextPage,
                                    hasPreviousPage,
                                    startCursor,
                                    endCursor
                                }
                            }        
                        }
                    }
                }
            }
        `,
    },
});
